import type { RouteRecordRaw } from 'vue-router'
import { contactsRoute } from '@/routes/user/contacts/contacts'
import { oldContactsSettingsRoute } from '@/routes/user/contacts/oldContactsSettings'
import { getTemplatesRoutes } from '@/routes/user/templates'
import { getServicesRoutes } from '@/routes/user/services'
import { composeMessageRouteName, getComposeRoutes } from '@/routes/user/compose'
import { getScheduledRoutes } from '@/routes/user/scheduled/scheduled'
import { getChatsRoutes } from '@/routes/user/messenger/chats'
import { reportingRoute } from '@/routes/user/reporting/reporting'
import { getGettingStartedRoutes } from '@/routes/user/getting-started/getting-started'
import { getTasksRoutes } from '@/routes/user/tasks/tasks'
import { getTicketsRoutes } from '@/routes/user/tickets/tickets'
import { getDealsRoutes } from '@/routes/user/deals/deals'
import { oldUserAccountsRoute } from '@/routes/user/accounts/accounts'
import { getHistoryRoutes } from '@/routes/user/history'
import { getSmsSurveysRoutes } from '@/routes/user/sms-survey/smsSurveys'
import { getFormsRoutes } from '@/routes/user/forms/forms'
import { getCarrierLookupRoutes } from '@/routes/user/lookup/carrierLookup'
import { getEmailLookupRoutes } from '@/routes/user/lookup/emailLookup'
import { settingsRoute } from '@/routes/user/settings'
import { getAutomationRoutes } from '@/routes/user/automations/automations'

export const getUserRoutes = (): RouteRecordRaw[] => [
  {
    name: 'user.base',
    path: '',
    redirect: { name: composeMessageRouteName },
    component: () => import('@/components/containers/BaseContainer.vue'),
    meta: {
      resolvers: [
        {
          service: 'MainSidebarRoutesResolverService',
        },
        {
          service: 'MainSidebarRoutesPrefetchResolverService',
        },
      ],
    },
    children: [
      ...getGettingStartedRoutes(),
      ...getComposeRoutes(),
      ...getChatsRoutes(),
      ...getTicketsRoutes(),
      contactsRoute as RouteRecordRaw,
      oldContactsSettingsRoute as RouteRecordRaw,
      ...getTasksRoutes(),
      ...getScheduledRoutes(),
      ...getHistoryRoutes(),
      ...getTemplatesRoutes(),
      ...getDealsRoutes(),
      ...getServicesRoutes(),
      ...getSmsSurveysRoutes(),
      ...getFormsRoutes(),
      ...getEmailLookupRoutes(),
      ...getCarrierLookupRoutes(),
      oldUserAccountsRoute,
      reportingRoute as RouteRecordRaw,
      settingsRoute as RouteRecordRaw,
      ...getAutomationRoutes(),
    ],
  },
]
